<template>
  <mf-loading-dialog :loading="$apollo.queries.campaign.loading">
    <edit :commercial.sync="campaign" :franchise="Boolean($route.query.franchise)" :is-new="isNew" />
  </mf-loading-dialog>
</template>

<script>
import { QUERY_GET_COMMERCIAL_BY_ID } from '@/modules/mobile/banners/graphql'
import offerScheduleCampaign from '@/modules/campanhas/views/mixins/offer-schedule-campaign.js'
import loadBenefitCampaignMixin from '@/modules/campanhas/cupom-desconto/mixins/load-benefit-campaign.js'

export default {
  components: {
    Edit: () => import('@/modules/mobile/banners/views/pages/Edit.vue'),
  },
  mixins: [offerScheduleCampaign, loadBenefitCampaignMixin],
  data: () => ({
    commercialId: '',
    campaign: {
      title: '',
      description: '',
      units: [],
      priority: 2,
      initial_date: '',
      final_date: '',
      image_url: '',
      type: 'NONE',
      link: '',
      status: 'DRAFT',
      action: {
        link: '',
        reference_id: '',
        type: '',
      },
    },
    isNew: true,
  }),
  computed: {
    isFranchisee() {
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
    editable() {
      return ['DRAFT', 'SCHEDULED'].includes(this.campaign.status)
    },
  },
  apollo: {
    campaign: {
      query: QUERY_GET_COMMERCIAL_BY_ID,
      notifyOnNetworkStatusChange: true,
      update({ commercial }) {
        return commercial || this.commercial
      },
      variables() {
        const franchise = Boolean(this.$route.query.franchise)
        const only_franchise = Boolean(this.$route.query.only_franchise)
        return {
          id: this.commercialId,
          franchise: franchise,
          only_franchise: only_franchise,
        }
      },
      skip() {
        if (!this.commercialId) return true
        return false
      },
      fetchPolicy: 'no-cache',
    },
  },
  async mounted() {
    this.commercialId = this.$route.params.id
    this.isNew = !this.commercialId
    this.campaign.priority = this.$route.query.franchise ? 2 : 5
    if (!this.isFranchisee) this.campaign.priority = 2
    if (this.commercialId?.length !== 24) this.commercialId = ''

    await this.loadBenefit({
      assignFieldsFn: ({ benefit, parsedSendDate, parsedFinalDate }) => {
        this.campaign.title = benefit.title
        this.campaign.description = benefit.description
        this.campaign.initial_date = parsedSendDate
        this.campaign.final_date = parsedFinalDate
        this.campaign.units = benefit.units

        this.campaign.segments = (benefit.segmentsData || []).map((s) => ({
          ...s,
          clients_qty: s.clientsQty,
          clients_refreshed_at: s.clientsRefreshedAt,
        }))
      },
    })
  },
}
</script>
